import React from 'react';
import { useCountry } from '../contexts/CountryContext';

export default function CountrySelector({ onSelect, selectedCode }) {
  const { countries, loading } = useCountry();

  const card = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '14px 18px',
    borderRadius: '10px',
    border: '2px solid transparent',
    background: '#111c30',
    cursor: 'pointer',
    transition: 'border-color 0.15s, background 0.15s',
    marginBottom: '10px',
    width: '100%',
    textAlign: 'left',
  };
  const cardSelected = { ...card, borderColor: '#00A8DB', background: '#0d2240' };
  const flag  = { fontSize: '28px', lineHeight: 1 };
  const info  = { flex: 1 };
  const cname = { color: '#e2e8f0', fontWeight: 600, fontSize: '15px', margin: 0 };
  const cur   = { color: '#7ab3cc', fontSize: '12px', margin: 0, marginTop: '2px' };
  const check = { color: '#00A8DB', fontSize: '18px', fontWeight: 700 };

  if (loading) {
    return (
      <div style={{ color: '#7ab3cc', textAlign: 'center', padding: '24px' }}>
        Loading countries…
      </div>
    );
  }

  if (!countries.length) {
    return (
      <div style={{ color: '#f87171', textAlign: 'center', padding: '24px' }}>
        No countries available. Please contact support.
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {countries.map(c => (
        <button
          key={c.code}
          type="button"
          style={selectedCode === c.code ? cardSelected : card}
          onClick={() => onSelect(c.code)}
        >
          <span style={flag}>{c.flag || '🌍'}</span>
          <span style={info}>
            <p style={cname}>{c.name}</p>
            <p style={cur}>{c.currency?.code} · {c.currency?.symbol}</p>
          </span>
          {selectedCode === c.code && <span style={check}>✓</span>}
        </button>
      ))}
    </div>
  );
}
